import { Link } from "react-router-dom"
import { Container } from "@/components/layout/Container"
import { Eyebrow } from "@/components/shared/Eyebrow"
import { getTreatmentsForProduct } from "@/content/treatments"
import type { ProductType } from "@/content/products"

interface ProductConditionsProps {
	productId: ProductType
	name: string
}

/**
 * "Padecimientos tratados": los tratamientos donde se usa este producto, como
 * chips que enlazan a `/tratamientos/:slug`. Cada tratamiento aborda un
 * padecimiento específico. Se muestran todos (los productos base pueden aparecer
 * en ~20 tratamientos); si no hay ninguno, la sección se omite.
 */
export function ProductConditions({ productId, name }: ProductConditionsProps): React.JSX.Element | null {
	const treatments = getTreatmentsForProduct(productId)
	if (treatments.length === 0) return null

	return (
		<section className="bg-background">
			<Container className="pb-24">
				<div className="mx-auto max-w-2xl text-center">
					<Eyebrow align="center">Padecimientos tratados</Eyebrow>
					<h2 className="mt-3 text-balance text-2xl font-semibold tracking-tight sm:text-3xl md:text-4xl">
						Tratamientos con {name}
					</h2>
					<p className="mt-4 text-pretty text-muted-foreground">
						Toca un padecimiento para ver el tratamiento donde se utiliza este producto.
					</p>
				</div>

				<ul className="mt-10 flex flex-wrap justify-center gap-3">
					{treatments.map(treatment => (
						<li key={treatment.id}>
							<Link
								to={`/tratamientos/${treatment.id}`}
								className="inline-flex h-11 items-center rounded-full border border-border bg-card px-5 text-sm font-medium ring-foreground/10 transition-colors hover:border-primary/40 hover:bg-primary/5 hover:text-primary"
							>
								{treatment.name}
							</Link>
						</li>
					))}
				</ul>
			</Container>
		</section>
	)
}
